// Reference: https://github.com/adobe/react-spectrum/blob/main/packages/%40react-stately/utils/src/number.ts

const MAX = Infinity;
const MIN = -Infinity;
const NAN = Number.NaN;
const STEP = 1;

export const clamp = (value: number, min = MIN, max = MAX) => Math.min(Math.max(value, min), max);

export const snapValueToStep = (value: number, min = NAN, max = NAN, step = STEP) => {
  const remainder = (value - (isNaN(min) ? 0 : min)) % step;

  let snappedValue =
    Math.abs(remainder) * 2 >= step
      ? value + Math.sign(remainder) * (step - Math.abs(remainder))
      : value - remainder;

  if (!isNaN(min)) {
    if (snappedValue < min) {
      snappedValue = min;
    } else if (!isNaN(max) && snappedValue > max) {
      snappedValue = min + Math.floor((max - min) / step) * step;
    }
  } else if (!isNaN(max) && snappedValue > max) {
    snappedValue = Math.floor(max / step) * step;
  }

  return snappedValue;
};

export const handleDecimalOperation = (operator: '-' | '+', value1: number, value2: number) =>
  operator === '+' ? value1 + value2 : value1 - value2;
